import * as zod from 'zod';

export const violationLimitsSchema = zod.object({
  /** Maximum allowed for L/D to start before L/D window start */
  early: zod.number().nullable().optional(),
  /** Maximum allowed for L/D to start after L/D window end */
  late: zod.number().nullable().optional(),
});
export type ViolationLimits = zod.infer<typeof violationLimitsSchema>;
export const orderViolationLimitsSchema = zod.object({
  load: violationLimitsSchema,
  discharge: violationLimitsSchema,
});
export type OrderViolationLimits = zod.infer<typeof orderViolationLimitsSchema>;

export const scenarioImprovementsParamsSchemaObject = {
  cargoExclusions: zod.enum(['warn', 'exclude']),
  /** Max allowed early/late for any order event */
  violationLimitsD: orderViolationLimitsSchema,
};
export const scenarioImprovementsParamsSchema = zod.object(
  scenarioImprovementsParamsSchemaObject,
);
export type ScenarioImprovementsParams = zod.infer<
  typeof scenarioImprovementsParamsSchema
>;

export const getScenarioImprovementsParamDefaults: () => ScenarioImprovementsParams =
  () => ({
    cargoExclusions: 'warn',
    violationLimitsD: {
      load: {
        early: 7,
        late: 7,
      },
      discharge: {
        early: 7,
        late: 7,
      },
    },
  });
